import {css} from '@emotion/react';
import styled from '@emotion/styled';

import {MapViewport} from '@/components/MapViewport';

export const Container = styled.div(
  () => css`
    position: absolute;
    inset: 0;
    display: flex;
    justify-content: start;
    padding: 16px;
    pointer-events: none;
    > * {
      pointer-events: all;
    }

    ${MapViewport} {
      flex: 1;
    }
  `
);
